import React, { useEffect, useState } from "react";
import DataTable from "../../../components/DataTable";
import { API_GET } from "../../../helpers/api";
import { setNotification } from "../../../helpers/notification";
import moment from "moment";
import { parameterNames, processNames } from "../../../constants/translations";
import {
  convertNumberToFrontend,
  convertAmountToFrontend,
} from "../../../helpers/convert";
const GeneralParameters = ({ t }) => {
  const [parameterData, setParameterData] = useState([]);

  const paramterTranslations = parameterNames(t);
  const processTranslations = processNames(t);
  const ORGANIZED_MARKET_STARTING_DAY = "organized_market_starting_day";
  const parametersColumns = [
    {
      name: t("pages.default.systemParameters.table.parameters"),
      selector: "parameterName",
      sortable: false,
      cell: (row) => {
        return (
          paramterTranslations[row.parameterName] ||
          processTranslations[row.parameterName]
        );
      },
    },
    {
      name: t("pages.default.systemParameters.table.values"),
      selector: "parameterValue",
      sortable: false,
      cell: (row) => {
        return (
          (row.parameterDateValue
            ? moment(row.parameterDateValue)
                .locale(window.localStorage.i18nextLng)
                .format("DD.MM.YYYY")
            : "") ||
          convertNumberToFrontend({
            num: row.parameterDecimalValue,
            digit: 2,
          }) ||
          convertAmountToFrontend(row.parameterValue)
        );
      },
    },
  ];

  useEffect(() => {
    getParameters();
    const parameterInterval = setInterval(() => {
      getParameters();
    }, 5000);

    return () => clearInterval(parameterInterval);
  }, []);

  const checkParameterNameIsEmpty = (paramName) => {
    return paramterTranslations[paramName] === undefined;
  };

  const getParameters = async () => {
    try {
      let obj = [];
      let res = await API_GET("system-parameter/parameter");
      let processRes = await API_GET("system-parameter/process");

      const processData = processRes.data.map((process, index) => ({
        id: `${process.id}-${index}`,
        parameterName: process.processName,
        parameterValue: `
        ${process.startHour}:${
          process.startMinute.toString().length === 1
            ? `0${process.startMinute}`
            : process.startMinute
        } - 
        ${process.endHour}:${
          process.endMinute.toString().length === 1
            ? `0${process.endMinute}`
            : process.endMinute
        }
                `,
      }));
      const foundParameter = res.data.find(
        (item) => item.parameterName === ORGANIZED_MARKET_STARTING_DAY
      );
      foundParameter.parameterName = "organized_market_opening_day";

      const organizedMarketDateRes = await API_GET(
        "system-parameter/session/first-open"
      );
      if (organizedMarketDateRes.data.sessionDate) {
        const organizedMarketDate = moment(
          organizedMarketDateRes.data.sessionDate
        ).locale(window.localStorage.i18nextLng);
        foundParameter.parameterValue = `${organizedMarketDate.format(
          "DD.MM.YYYY"
        )} - ${organizedMarketDate.format("dddd")}`;
      } else {
        foundParameter.parameterValue = "-";
      }

      for (let p of res.data) {
        if (!checkParameterNameIsEmpty(p.parameterName)) {
          obj.push(p);
        }
      }
      setParameterData([...processData, ...obj]);
    } catch (e) {
      setNotification("error", e.response.data.message);
    }
  };

  return (
    <div className="km__p--card">
      <DataTable columns={parametersColumns} data={parameterData} />
    </div>
  );
};

export default GeneralParameters;
